import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransferService } from 'src/app/transfer/services/transfer.service';

@Component({
  selector: 'app-dialog-upload',
  templateUrl: './dialog-upload.component.html',
  styleUrls: ['./dialog-upload.component.scss']
})
export class DialogUploadComponent {
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() showDialog!: boolean;
  @Input() isPublicUpload?: boolean = false;

  constructor(
    private transferService: TransferService
  ) {}

  onUpload = (files: any) => {
    if(this.isPublicUpload) {
      this.transferService.queuePublicUpload(files);
    } else {
      this.transferService.queueUpload(files, false);
    }
    this.closeDialog();
  }

  closeDialog = () => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
    }, 0);
  }
}
